module.exports = __webpack_public_path__ + "static/media/logo_soymas.e5e296fa.png";